<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<a id="title2"><h1 class="title-acknowPage"><strong class="b">Acknowledgements</strong></h1>
<p class="p">I have been honoured and privileged to work with two giants of local history. I now know that Christmas comes more than once a year – indeed, every time I meet up with them, another ‘Pandora’s Box’ is opened. Between them they have over a hundred years experience in the field of local history research and make my twenty-five seem paltry. They have both been unstintingly generous, kind and friendly, whether it was in Stanley’s shed or Leslie’s attic, and I can only hope that the trust they have placed in me will be in some way acknowledged by the publication of these books. My grateful thanks to you both.</p>
<div class="illustype_image"><div class="caption"><p class="p">Stanley Sheead and Leslie Robinson.</p></div>
<div class="image"><img alt="e9781783408566_i0003.jpg" src="images/e9781783408566_i0003.jpg"/></div></div></a></div><a id="title2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783408566_ack01.vue?2069312f